import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import TextField from '../../elements/form/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import axios from 'axios';
import SelectField from '../../elements/form/SelectField';
import { authHeader } from '../../../utils';
import { fetchApplications } from '../../../store/actions/applicationsActions';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';

const ValidatePayment = ({closeFunction, reload}) => {
    const dispatch = useDispatch()
    const [txnId, setTxnId] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const [validating, setValidating] = useState(false);
    const applicationsSelector = useSelector(state => state.applications)

    useEffect(() => {
        dispatch(fetchApplications('status=PROVISIONAL_OFFER', 0, 0))
        return () => {
            
        };
    }, []);

    const [paymentFor, setPaymentFor] = useState('');

    const paymentForOptions = [
        {
            label: 'New Application',
            value: 'new-application'
        },
        {
            label: 'Admission Offer Acceptance',
            value: 'admission-offer-acceptance'
        },
        // {
        //     label: 'School fees',
        //     value: 'school-fees'
        // }
    ]

    const [paymentItemId, setPaymentItemId] = useState('');
    const validateForm = () => {
        let errors = {}
        
        if(!txnId || txnId === '') {
            errors.txnId = true
        }
        
        if(!paymentFor || paymentFor === '') {
            errors.paymentFor = true
        }
        
        // if(paymentFor !== 'new-application' && (!paymentItemId || paymentItemId === '')) {
        //     errors.paymentItemId = true
        // }

        setValidationErrors(errors)
        return errors
    }

    const validatePayment = async () => {
        if (Object.values(validateForm()).includes(true)) {
            
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please provide transaction id'
                }}}
            })
            return
        }
        try {
            const headers = authHeader()

            const payload = {
                paymentFor,
                txnId,
                // paymentItemId
            }
            setValidating(true)

            await axios.post(`${process.env.REACT_APP_BASE_URL}/payments/record-payment`, payload, { headers })  
            
            dispatch({
                type: SET_SUCCESS,
                payload: 'Payment verified successfully'
            })
      
            setValidating(false)
            reload()
            closeFunction()
            
        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error: error
            })
            setValidating(false)
        }
    }

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>Please provide the transaction ID from flutterwave to manually validate this payment</p>
            </div>
            <div className='w-full my-2'>
                <TextField
                    inputLabel="Transaction ID" 
                    fieldId="txn-id" 
                    requiredField={true}
                    inputType="text" 
                    inputPlaceholder={`Transaction id from payment processor`}
                    preloadValue={txnId || ''}
                    hasError={validationErrors && validationErrors.txnId} 
                    returnFieldValue={(value)=>{setTxnId(value)}}
                />
            </div>

            <div className='w-full my-2'>
                <SelectField
                    selectOptions={paymentForOptions}
                    inputLabel="Select what the payment was made for"
                    titleField="label"
                    displayImage={false} 
                    imageField=""
                    requiredField={false}
                    preSelectedIndex={null}
                    fieldId="center-select"
                    hasError={validationErrors && validationErrors.paymentFor}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {setPaymentFor(value.value)}}
                /> 
            </div>

            {paymentFor === 'admission-offer-acceptance' && <div className='my-2'>
                {applicationsSelector?.applications?.applications.length > 0 ?
                    <AutocompleteSelect
                        selectOptions = {applicationsSelector?.applications?.applications}
                        inputLabel = "Select application"
                        requiredField={true}
                        titleField = "fullName"
                        displayImage = {false}
                        imageField = ""
                        fieldId = "applicant"
                        preSelected={''}
                        preSelectedLabel='value'
                        hasError = {validationErrors && validationErrors.application}
                        returnFieldValue={(value)=>{setPaymentItemId(value._id)}}
                        position='bottom-[50px]'
                    />
                    :
                    <p className='text-xs p-[10px] bg-gray-100'>There are no applications with admission offers pending acceptance</p>
                }
            </div>}

            <div className="mt-12 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Validate Payment`}
                    buttonAction={()=>{validatePayment()}}
                    processing={validating}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default ValidatePayment